import produce from 'immer';
import findIndex from 'lodash/findIndex';

import {
  VERIFY_ORDER,
  CANCEL_ORDER,
  FETCH_ORDERS_FAIL,
  FETCH_ORDERS_REQUESTED,
  FETCH_ORDERS_SUCCEED,
  UPDATE_ORDER
} from './actionTypes';

const initialState = {
  orders: [],
  isOrdersLoading: false,
  error: null
};

const OrdersErrors = {
  fetchOrdersFailed: 'Не удалось обновить список заказов.',
  editOrderFailed: 'Не удалось сохранить данные заказа.'
};

const ordersReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDERS_REQUESTED:
      draft.isOrdersLoading = true;
      draft.error = null;
      return draft;

    case FETCH_ORDERS_SUCCEED:
      draft.orders = action.payload.orders;
      draft.isOrdersLoading = false;
      return draft;

    case FETCH_ORDERS_FAIL:
      draft.isOrdersLoading = false;
      draft.error = action.payload.error;
      draft.errorText = OrdersErrors.editOrderFailed;
      return draft;

    case CANCEL_ORDER:
      draft.isOrdersLoading = true;
    return draft;

    case VERIFY_ORDER:
      draft.isOrdersLoading = true;
    return draft;

    case UPDATE_ORDER:
      draft.orders[findIndex(draft.orders,{id:action.payload.order.id})] = action.payload.order
      draft.isOrdersLoading = false;
      return draft;

    default:
      return draft;
  }
})

export default ordersReducer;



// WEBPACK FOOTER //
// ./src/store/orders/reducer.js